export default {
    title: "Survey Submitted",
    header: "@:views.survey.submitted.title",
    message: "Thank you for your feedback.",
}